(function (window) {

    var adaptiveMenu = function () {
        var menuStack = [];
        var ui = {};
        var isMobile;
        var SHOW_CSS = 'open';
        var OVERLAY = 'overlay';
        var NO_SCROLL = 'noscroll';
        var MEDIA_QUERY = '(max-width: 991px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$nav = $('.js-menu-wrap');
            ui.$hamburger = $('.js-mobile-menu-toggler');
            ui.$closeBtn = $('.js-close-btn');
            ui.$navToggler = $('.js-submenu-toggler');
            ui.$mobileClicktoggler = $('.has-children');
            ui.$backBtn = $('.js-black-btn');
            ui.$sidebar = $('.mega-menu-sidebar');
            ui.$megaSidebarNavItem = $('.js-sidebar-item');
            ui.$megaPanel = $('.mega-menu-panel');
            ui.$sidebarNavToggler = $('.js-sidebar-toggler');
            ui.$megaMenu = $('.mega-menu');
            ui.$bodyOpen = $('body.noscroll');
            ui.$simpleToggler = $('.mega-simple-dropdown .js-simplemenu-item');
            ui.$simpleDropDown = $('.mega-simple-dropdown .submenu-dropdown');
        }

        function showMobileMenu() {
            event.stopPropagation();
            ui.$nav.addClass(SHOW_CSS);
            ui.$body.addClass(NO_SCROLL);
        }

        function hideMobileMenu() {
            ui.$nav.removeClass(SHOW_CSS);
            ui.$body.removeClass(NO_SCROLL);
            ui.$nav.find('.active').removeClass('active');
            ui.$bodyOpen.off('click', hideMobileMenu);
        }

        function checkMenuOpen (e) {
            if(!ui.$body.hasClass(NO_SCROLL)) {
                return;
            }
            if (!$(e.target).closest(ui.$nav).length) {
                hideMobileMenu()
            }
        }

        function toggleSubNav(e) {
            if(e.which == 13) {
                var $target = $(e.target);
                var $parent = $target.closest('li');
                if ($parent.hasClass('active')){
                    ui.$nav.find('.active').removeClass('active');
                }else {
                    ui.$nav.find('.active').removeClass('active');
                    $parent.addClass('active');
                }
            }
        }

        function closeMegaMenu(e) {
            ui.$nav.find('.active').removeClass('active');
        }

        function toggleSidebarPanel(e) {
            if(e.which == 13) {
                e.preventDefault();
                var targetData = $(e.target).attr("data-panel");
                var $target = ui.$megaPanel.find("div[data-panel='" + targetData + "']");
                var $sideBarItem = ui.$sidebar.find("a[data-panel='" + targetData + "']");
                if ($target.hasClass('active')){
                    ui.$megaSidebarNavItem.removeClass('active');
                    ui.$megaPanel.find("div.panel-item").removeClass('active');
                }else {
                    ui.$megaPanel.find("div.panel-item").removeClass('active');
                    ui.$megaSidebarNavItem.removeClass('active');
                    $sideBarItem.addClass('active');
                    $target.addClass('active');
                }
            }
        }

        function toggleMobileSubNav(e) {
            if(mql.matches) {
                e.preventDefault();
                var $target = $(e.target);
                if(!$target.hasClass('js-sidebar-item')) {
                    $target.siblings('.submenu-dropdown').addClass('active');
                }else {
                    var targetData = $(e.target).attr("data-panel");
                    var $target = ui.$megaPanel.find("div[data-panel='" + targetData + "']");
                    console.log($target);
                    $target.addClass('active');
                }
            }
        }

        function toggleMegaSimple(e) {
            if(!mql.matches) {
                e.preventDefault();
                var $target = $(e.target);
                $target.closest('li').toggleClass('active');
                $target.siblings('.submenu-dropdown').toggleClass('active');
            }
        }

        function mobileBackBtn(e) {
            if(mql.matches) {
                e.preventDefault();
                var $target = $(e.target);
                $target.closest('.submenu-dropdown').removeClass('active');
            }
        }

         function toggleSubPanel(e) {
            if(!mql.matches) {
                e.preventDefault();
                var target = $(e.target).attr("data-panel");
                ui.$megaPanel.find("div.panel-item").removeClass('active');
                ui.$megaSidebarNavItem.removeClass('active');
                $(e.target).addClass('active');
                ui.$megaPanel.find("div[data-panel='" + target + "']").addClass('active');
            }
        }



        function handleMediaQueryChange(mql) {
            isMobile = mql.matches ? true : false;
            if (isMobile) {
                ui.$nav.find('.active').removeClass('active');
            } else {
                hideMobileMenu();
            }
        }

        function bindEvents() {
            ui.$hamburger.on('click', showMobileMenu);
            ui.$closeBtn.on('click', hideMobileMenu);
            ui.$body.on('click', checkMenuOpen);
            ui.$navToggler.on('keypress', toggleSubNav);
            ui.$sidebarNavToggler.on('keypress', toggleSidebarPanel);
            ui.$mobileClicktoggler.on('click', toggleMobileSubNav);
            ui.$backBtn.on('click', mobileBackBtn);
            ui.$megaSidebarNavItem.on('mouseenter', toggleSubPanel);
            ui.$simpleToggler.on('click', toggleMegaSimple)
            mql.addListener(handleMediaQueryChange);
            ui.$megaMenu.on('focusout', function(e) {
                if(!mql.matches) {
                    var $currentMega = $(e.target).closest('.mega-menu');
                    if ($currentMega.has(e.relatedTarget).length == 1) {
                        // don't react to this
                        return;
                    }
                    closeMegaMenu();
                }
            });
        }

        function init() {
            cacheUI();
            if(ui.$navToggler.length && ui.$megaMenu.length) {
                bindEvents();
                handleMediaQueryChange(mql);
            }
        }

        return {
            init: init
        };
    };

    var menu = adaptiveMenu();
    menu.init();
})(window);
